export enum EDeliveryType {
    deliveryAndSetup = 'delivery_and_setup',
    onlyDelivery = 'only_delivery',
}
